$(() => {
    if($('body').hasClass('scrollControl')){
        new scrollControl();
    }
});

class scrollControl {

    constructor() {
        this.isTouchDevice = this.isTouchDevice();
        this.init();
        this.positions = [
            'section1', 'section2', 'section3', 'section4', 'funkce', 'reference'
        ];

        this.keyboard__events();
        this.swipe__events();
    }

    init() {
        $('body')
            .attr('data-keyboard', true)
            .attr('data-touch', this.isTouchDevice);
    }

    isTouchDevice() {
        var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
        var mq = function (query) {
            return window.matchMedia(query).matches;
        };

        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
            return true;
        }

        // include the 'heartz' as a way to have a non matching MQ to help terminate the join
        // https://git.io/vznFH
        var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
        return mq(query);
    }

    getBodyPosition() {
        return $('body').attr('data-position')
    }

    isKeyBoardEnabled() {
        let out = false;
        if (typeof $('body').attr('data-keyboard') === 'undefined') {
            out = true;
        } else {
            if ($('body').attr('data-keyboard') === 'true') {
                out = true;
            } else {
                out = false;
            }
        }
        return out;
    }

    controller(direction) {

        let position = this.getBodyPosition();
        let index = this.positions.indexOf(position);
        let scrollTo = position;

        if (direction === 'up') {
            if (typeof this.positions[index - 1] !== "undefined") {
                scrollTo = this.positions[index - 1];
            }
        } else {
            if (typeof this.positions[index + 1] !== "undefined") {
                scrollTo = this.positions[index + 1];
            }
        }

        this.scroll(scrollTo);
    }

    scroll(scrollTo) {
        if (typeof scrollTo !== 'undefined') {
            let editPos = 0;

            if (scrollTo === 'reference') {
                let headerHeight = $('#pageHeader').height();
                editPos = headerHeight * -1;
            }

            if ('#' + scrollTo.length) {
                scrollWin('#' + scrollTo, 1000, editPos);
            }
        }
    }

    keyboard__events() {

        let that = this;

        keyboardJS.bind(['up', 'left'], function (e) {
            if (that.isKeyBoardEnabled()) {
                e.preventDefault();
                that.controller('up');
            }
        });

        keyboardJS.bind(['down', 'right'], function (e) {
            if (that.isKeyBoardEnabled()) {
                e.preventDefault();
                that.controller('down');
            }
        });

        $('#scrollNavigation button').on('click', function () {
            that.scroll($(this).data('href'));
        })
    }

    swipe__events() {
        let that = this;

        if (that.isTouchDevice) {
            $("#carousel").swipe({
                swipeLeft: function () {
                    that.controller('down');
                },
                swipeRight: function () {
                    that.controller('up');
                },
                threshold: 75
            });
        }
    }
}